import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { auth, firestore} from "../../firebase/firebase.js";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { useAuth } from "../../utils/AuthContext/authcontext";
import NotificationStack from '../NotificationStack/NotificationStack';

// Create Context
const NotificationContext = createContext();

// Provider Component
export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const { user, userData, logout, login } = useAuth();
  const [globalError, setGlobalError] = useState(null);
  const [messages, setMessages] = useState([]);

  const notify = useCallback((type, content) => {
    var id = 0;
	setTimeout(() => {
	  id = Date.now();
      setMessages(prev => [...prev, { id, type, content }]);
    }, 10);
    

    setTimeout(() => {
      setMessages(prev => prev.filter(m => m.id !== id));
    }, 4000);
  }, []);
  
  
  useEffect(() => {
    if (user != null && userData != null) {
		const q = query(collection(firestore, "users", user.uid, "notifications"), orderBy("timestamp", "desc")
		);

		const unsubscribe = onSnapshot(q, (snapshot) => {
		  setNotifications(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
		});

		return () => unsubscribe();
	}
  }, []);//user, userData]);

  return (
    <NotificationContext.Provider value={{ notifications, notify, globalError  }}>
      {children}
	  <NotificationStack messages={messages} />
    </NotificationContext.Provider>
  );
};

// Custom hook to use NotificationContext
export const useNotifications = () => useContext(NotificationContext);
